// Listings based in Iran (the API files them under this category and sets country "Iran";
// see cheesta-api/src/iranLocation.ts). Shown with their own colour and tag so they are
// never mistaken for Australian businesses.
export const IRAN_CATEGORY_SLUG = 'iran-australia-business';
export const IRAN_TAG_LABEL = 'کسب‌وکار در ایران';
export const IRAN_COLOR = '#0f8a3c';      // tag background / card outline (Iranian flag green)
export const IRAN_TINT = '#f1faf4';       // card body tint

export const isIranBusiness = (b: { country?: string | null; category?: { slug?: string | null } | null } | null | undefined) => {
    if (!b) return false;
    const country = String(b.country || '').trim().toLowerCase();
    return b.category?.slug === IRAN_CATEGORY_SLUG
        || country === 'iran' || country === 'ir' || country === 'ایران' || country.startsWith('iran');
};
